import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayersCount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_30494",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 100,
		height: 100,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 99,
			height: 99,
			fill: "#C4C4C4",
			stroke: "#9EA9B9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_30494)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask1_2938_30494",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: -3,
			y: -3,
			width: 105,
			height: 105,
			children: /* @__PURE__ */ _jsx("rect", {
				x: -3,
				y: -3,
				width: 105,
				height: 105,
				fill: "#C4C4C4"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask1_2938_30494)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6027 71.903C39.6019 71.903 29.8097 68.6635 29.0736 64.5405H29V79.122C29 83.4658 39.0867 86.9999 51.6029 86.9999C64.1191 86.9999 74.2057 83.4658 74.2057 79.122V64.5405H74.1322C73.3957 68.6635 63.6036 71.903 51.6027 71.903Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6029 71.9032C63.6037 71.9032 73.3959 68.6636 74.132 64.5407C74.2056 64.3934 74.2056 64.1726 74.2056 64.0253C74.2057 59.6815 64.1191 56.1475 51.6029 56.1475C39.0867 56.1475 29 59.6815 29 64.0253C29 64.1726 29 64.3934 29.0736 64.5407C29.8099 68.6636 39.602 71.9032 51.6029 71.9032Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6027 56.5866C39.6019 56.5866 29.8097 53.3471 29.0736 49.2241H29V63.8056C29 68.1494 39.0867 71.6834 51.6029 71.6834C64.1191 71.6834 74.2057 68.1494 74.2057 63.8056V49.2241H74.1322C73.3957 53.3471 63.6036 56.5866 51.6027 56.5866Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6029 56.5868C63.6037 56.5868 73.3959 53.3472 74.132 49.2243C74.2056 49.077 74.2056 48.8562 74.2056 48.7089C74.2057 44.3651 64.1191 40.8311 51.6029 40.8311C39.0867 40.8311 29 44.3651 29 48.7089C29 48.8562 29 49.077 29.0736 49.2243C29.8099 53.3472 39.602 56.5868 51.6029 56.5868Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6027 42.1711C39.6019 42.1711 29.8097 38.9316 29.0736 34.8086H29V49.3901C29 53.7339 39.0867 57.2679 51.6029 57.2679C64.1191 57.2679 74.2057 53.7339 74.2057 49.3901V34.8086H74.1322C73.3957 38.9316 63.6036 42.1711 51.6027 42.1711Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6029 42.1712C63.6037 42.1712 73.3959 38.9317 74.132 34.8087C74.2056 34.6615 74.2056 34.4406 74.2056 34.2934C74.2057 29.9496 64.1191 26.4155 51.6029 26.4155C39.0867 26.4155 29 29.9496 29 34.2934C29 34.4406 29 34.6615 29.0736 34.8087C29.8099 38.9317 39.602 42.1712 51.6029 42.1712Z",
					fill: "#FDF1E6",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6027 27.7556C39.6019 27.7556 29.8097 24.516 29.0736 20.3931H29V34.9745C29 39.3183 39.0867 42.8524 51.6029 42.8524C64.1191 42.8524 74.2057 39.3183 74.2057 34.9745V20.3931H74.1322C73.3957 24.516 63.6036 27.7556 51.6027 27.7556Z",
					fill: "#F6DCC4",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6029 27.7557C63.6037 27.7557 73.3959 24.5162 74.132 20.3932C74.2056 20.2459 74.2056 20.0251 74.2056 19.8779C74.2057 15.5341 64.1191 12 51.6029 12C39.0867 12 29 15.5341 29 19.8779C29 20.0251 29 20.2459 29.0736 20.3932C29.8099 24.5162 39.602 27.7557 51.6029 27.7557Z",
					fill: "#F6DCC4",
					stroke: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.288 74.8971V80.4971H50.248V75.7691H49.064V74.8971H51.288Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.408 65.9388V66.8188H49.28V66.1228L51.504 64.0108C51.7547 63.7708 51.9227 63.5628 52.008 63.3868C52.0987 63.2055 52.144 63.0268 52.144 62.8508C52.144 62.5895 52.056 62.3895 51.88 62.2508C51.704 62.1122 51.4453 62.0428 51.104 62.0428C50.5333 62.0428 50.096 62.2375 49.792 62.6268L49.064 62.0668C49.2827 61.7735 49.576 61.5468 49.944 61.3868C50.3173 61.2215 50.7333 61.1388 51.192 61.1388C51.8 61.1388 52.2853 61.2828 52.648 61.5708C53.0107 61.8588 53.192 62.2508 53.192 62.7468C53.192 63.0508 53.128 63.3362 53 63.6028C52.872 63.8695 52.6267 64.1735 52.264 64.5148L50.768 65.9388H53.408Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.736 48.7999C52.2533 48.8639 52.648 49.0399 52.92 49.3279C53.192 49.6159 53.328 49.9759 53.328 50.4079C53.328 50.7332 53.2453 51.0292 53.08 51.2959C52.9147 51.5626 52.664 51.7759 52.328 51.9359C51.9973 52.0906 51.592 52.1679 51.112 52.1679C50.712 52.1679 50.3253 52.1119 49.952 51.9999C49.584 51.8826 49.2693 51.7226 49.008 51.5199L49.456 50.7119C49.6587 50.8826 49.904 51.0186 50.192 51.1199C50.4853 51.2159 50.7867 51.2639 51.096 51.2639C51.464 51.2639 51.752 51.1892 51.96 51.0399C52.1733 50.8852 52.28 50.6772 52.28 50.4159C52.28 50.1546 52.1787 49.9519 51.976 49.8079C51.7787 49.6586 51.4747 49.5839 51.064 49.5839H50.552V48.8719L51.824 47.3599H49.28V46.4879H53.096V47.1839L51.736 48.7999Z",
					fill: "#A35705"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.344 37.1377H52.352V38.4097H51.344V37.1377H48.272V36.4177L51.032 32.8097H52.144L49.544 36.2577H51.376V35.1297H52.352V36.2577H53.344V37.1377Z",
					fill: "#A35705"
				})
			]
		})]
	})]
});
export default SvgLayersCount;
